// Coach Image Mapping Utility
// Maps coach IDs to their corresponding avatar images

export const coachImageMap: Record<string, string> = {
  // Main coaches with full avatar images
  'samuel': '/coach-avatars/Samuel-pic.jpg',
  'arjun': '/coach-avatars/Arjun_EmpathEAR_Coach_Avatar_34714366.png',
  'maya': '/coach-avatars/Maya_Career_Coach_Avatar_5c657077.png',
  'aisha': '/coach-avatars/Aisha-pic.jpg',
  'rohan': '/coach-avatars/Rohan_Performance_Coach_Avatar_450e031f.png',
  'zara': '/coach-avatars/Zara_Life_Coach_Avatar_7a3ec57d.png',
  'rajesh': '/coach-avatars/Rajesh-pic.jpg',
  'vikram': '/coach-avatars/Vikram_Performance_Coach_Avatar_98920136.png',
  'priya': '/coach-avatars/Priya_Career_Coach_Avatar_ca2e0841.png',
  'kavya': '/coach-avatars/Kavya_Life_Coach_Avatar_2fb0af31.png',
  'meera': '/coach-avatars/Meera_HiPo_Coach_Avatar_c4738f33.png',
  
  // Alternative mappings for different naming conventions
  'elena': '/coach-avatars/Aria_HiPo_Coach_Avatar_eb8bae99.png', // Fallback
  'david': '/coach-avatars/Samuel_Leadership_Coach_Avatar_0cdaf0f8.png', // Fallback
};

// Utility function to get coach image with fallback
export const getCoachImage = (coachId: string): string => {
  const image = coachImageMap[coachId.toLowerCase()];
  
  if (image) {
    return image;
  }
  
  // Fallback to a default coach image if not found
  return '/coach-avatars/Samuel_Leadership_Coach_Avatar_0cdaf0f8.png';
};

// Utility function to check if coach has image
export const hasCoachImage = (coachId: string): boolean => {
  return coachId.toLowerCase() in coachImageMap;
};

// Get coach image with error handling
export const getCoachImageSafe = (coachId: string): string | null => {
  try {
    return getCoachImage(coachId);
  } catch (error) {
    console.warn(`Failed to load image for coach: ${coachId}`, error);
    return null;
  }
};
